import { selectAllRoutes } from 'components/GlobalState/selectors/selectAllRoutes';
import { type FC, memo } from 'react';
import { useRoutes } from 'react-router-dom';

import { useGlobalStateContextSelectors } from 'components/GlobalState/GlobalStateModel';

const BareRoutesConfig: FC = () => {
  const globalStateCtxProps = useGlobalStateContextSelectors({
    allRoutes: selectAllRoutes,
  });

  return useRoutes(globalStateCtxProps.allRoutes);
};

export const RoutesConfig = memo(BareRoutesConfig);
